<template>
  <v-layout row justify-center>
    <v-dialog v-model="value" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Voters</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="save" :disabled="!(opts.disabled && this.table.values.length > 0)">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
          <section>
            <div class="upload--container" v-if="!opts.disabled">
              <div v-if="failure">
                <h2>
                  {{ failure }}
                </h2>
              </div>
              <div class="upload--file-container">
                <p>Files: {{file.name || "FILE NOT UPLOADED"}}</p>
              </div>

              <input type="file" :accept="opts.accept" :multiple="opts.multiple" ref="fileInput" @change="inputChange">
              <div class="upload--btn-choose">
                <v-btn large color="primary" block depressed @click.native="chooseFileClick" ref="btn">Choose File</v-btn>
              </div>
            </div>
          </section>
          <section v-if="this.table.values.length > 0 && opts.disabled">
            <div style="margin-top: 150px; padding: 0 100px;">
              <h2 style="text-align: center; font-size: 50px;">Voters</h2>
              <v-data-table
                :headers="table.fields"
                :items="table.obj"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.votePower }}</td>
                </template>
              </v-data-table>
            </div>
          </section>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Papa from "papaparse";
import gql from "graphql-tag";
import { coreClient } from "../../../apollo";
export default {
  data() {
    return {
      opts: {
        accept: ".csv",
        multiple: false,
        disabled: false
      },
      file: {
        name: "",
        value: ""
      },
      result: null,
      failure: null,
      table: {
        fieldNames: [],
        values: [],
        obj: [],
        fields: [
          {
            text: "Name",
            value: "name"
          },
          {
            text: "Email",
            value: "email"
          },
          {
            text: "Vote Power",
            value: "votePower"
          }
        ]
      }
    };
  },
  props: ["value", "event"],
  watch: {
    "table.fieldNames"() {
      if (this.table.fieldNames) {
        let ok = ["name", "email", "votepower"].every(el => {
          return this.table.fieldNames.indexOf(el) > -1;
        });

        if (!ok) {
          this.opts.disabled = false;
          this.file.name = null;
          this.file.value = null;

          this.failure =
            "Failed to Parse the CSV. Please make sure it is in the valid format.";
          return;
        }

        this.table.obj = this.table.values.map(value => {
          return {
            name: value[0],
            email: value[1],
            votePower: parseFloat(value[2])
          };
        });

        return;
      }
    }
  },
  methods: {
    parse() {
      Papa.parse(this.file.value, {
        complete: ({ errors, data }) => {
          if (errors.length > 0) {
            this.disabled = false;
            this.result = null;
            this.failure = "Failed to parse the CSV File!";
            return;
          }

          this.result = data.map(el =>
            el.map(e => e.toLowerCase().replace(/\s+/, ""))
          );

          if (
            this.result[this.result.length - 1][0] == "" ||
            this.result[this.result.length - 1][0] == null
          ) {
            this.result.splice(this.result.length - 1, 1);
          }

          this.table.fieldNames = this.result[0].map(res => res.toLowerCase());
          this.table.values = this.result.slice(1);
          return;
        }
      });
    },
    inputChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      const filesArray = (f => {
        return Array.from(f);
      })(files);

      if (files) {
        if (files.length > 0) {
          this.file.name = [...files].map(file => file.name).join(", ");
        } else {
          this.file.name = null;
        }
      } else {
        this.file.name = $event.target.value.split("\\").pop();
      }

      this.file.value = filesArray[0];
      this.opts.disabled = true;
      this.failure = null;
      this.parse();
    },
    chooseFileClick() {
      if (!this.opts.disabled) {
        this.$refs.fileInput.click();
      }
    },
    closeDialog() {
      this.$emit("input", false);
    },
    async save() {
      this.disabled = true;
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createVoters($voters: [VoterInput!]!, $eventId: String!) {
              createVoters(voters: $voters, eventId: $eventId) {
                id
                name
                email
                votePower
              }
            }
          `,
          variables: {
            eventId: this.event.id,
            voters: this.table.obj
          }
        });

        this.$emit("update");
        this.$emit("input", false);
      } catch (e) {
        this.$emit("fail", e);
        this.$emit("input", false);
      }
      this.disabled = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/Upload.styl';

input[type=file] {
  position: absolute;
  left: -99999px;
}
</style>
